module.exports = __webpack_public_path__ + "static/funnel-64c9eafbd2852aeba1439939a1f51900.svg";